import { select, Store } from '@ngrx/store';
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import {
  selectTagsInStore,
  selectTagsPageLoading,
  selectTagsShowInitWaitingMessage,
} from '../_selectors/tag.selectors';

export class TagsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectTagsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectTagsShowInitWaitingMessage));

    this.store.pipe(select(selectTagsInStore)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
